import React from 'react'
import {
	Divider, Row, Col, Table, Tag,
} from 'antd'
import NumberFormat from 'react-number-format'

const shiftItemsColumns = [{
		title: 'Tipo',
		dataIndex: 'type',
		key: 'type',
		render: (type) => {
			let name = 'Billete'
			if (type === 'coin') name = 'Moneda'

			return <span>{name}</span>
		},
	},
	{
		title: 'Denominacion',
		dataIndex: 'denomination',
		key: 'denomination',
	},
	{
		title: 'Cantidad',
		dataIndex: 'amount',
		key: 'amount',
	}]

const ShiftsReportDetail = (props) => {
	const { shift } = props
	return (
		<div>
			<Row gutter={{ xs: 8, sm: 16, md: 24 }}>
				<Col span="12">
					<Row style={{ marginBottom: 12 }}>
						<Col span="12">
							<span
								style={{
									fontWeight: 'bold',
									display: 'block',
								}}
							>
								Usuario
							</span>
							<span>{shift.user.full_name}</span>
						</Col>
						<Col span="12">
							<span
								style={{
									fontWeight: 'bold',
									display: 'block',
								}}
							>
								Sucursal
							</span>
							<span>{shift.subsidiary.name}</span>
						</Col>
					</Row>
                    <Row style={{ marginBottom: 12 }}>
						<Col span="12">
							<span
								style={{
									fontWeight: 'bold',
									display: 'block',
								}}
							>
								Fecha inicio
							</span>
							<span>{shift.start_datetime}</span>
						</Col>
						<Col span="12">
							<span
								style={{
									fontWeight: 'bold',
									display: 'block',
								}}
							>
								Fecha de termino
							</span>
							<span>{shift.end_datetime}</span>
						</Col>
                    </Row>
					<Divider>Ventas</Divider>
					<Row>
						<Col span="12">Ventas efectivo</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.cash_amount}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span="12">Ventas tarjeta</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.card_amount}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span="12">Ventas cheque</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.check_amount}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span="12">Ventas transferencia</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.transfer_amount}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span="12">Ventas a credito</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.credit_amount?shift.credit_amount:0}
								/>
							</div>
						</Col>
					</Row>
					<Row style={{ margin: '12px 0' }}>
						<Col span="12">Venta total</Col>
						<Col span="12">

							

							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={
										parseFloat(shift.cash_amount)
										+ parseFloat(shift.card_amount)
										+ parseFloat(shift.transfer_amount)
										+ parseFloat(shift.check_amount)
									}
								/>
							</div>
						</Col>
					</Row>
					<Divider>Efectivo</Divider>
					<Row>
						<Col span="12">Fondo inicial</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.initial_cash}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span="12">Efectivo estimado</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.estimated_cash}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span="12">Efectivo final</Col>
						<Col span="12">
							<div style={{ textAlign: 'right' }}>
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={shift.final_cash}
								/>
							</div>
						</Col>
					</Row>

					<div style={{ textAlign: 'center', marginTop: 12 }}>
						{+shift.final_cash === +shift.estimated_cash ? (
							<Tag color="green">Todo en orden</Tag>
						) : null}

						{+shift.final_cash < +shift.estimated_cash ? (
							<Tag color="red">
								{'Faltante de '}
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={
										+shift.estimated_cash
										- +shift.final_cash
									}
								/>
							</Tag>
						) : null}

						{+shift.final_cash > +shift.estimated_cash ? (
							<Tag color="blue">
								{'Sobrante de '}
								<NumberFormat
									decimalScale={2}
									fixedDecimalScale
									thousandSeparator
									prefix="$"
									displayType="text"
									value={
										+shift.final_cash
										- +shift.estimated_cash
									}
								/>
							</Tag>
						) : null}
					</div>
				</Col>

				<Col span="12">
					<Table
						size="small"
						dataSource={shift.items}
						columns={shiftItemsColumns}
						pagination={false}
					/>
				</Col>
			</Row>
		</div>
	)
}

export default ShiftsReportDetail
